import { PropsWithChildren } from 'react';
import styles from './Heading.module.scss';
import { titleSizeType } from '../../../../store/features/siteArticles';

type HeadingSizeTypes = {
  H1: 'h1';
  H2: 'h2';
  H3: 'h3';
  H4: 'h4';
  H5: 'h5';
  H6: 'h6';
};

const HeadingSizeMap: HeadingSizeTypes = {
  H1: 'h1',
  H2: 'h2',
  H3: 'h3',
  H4: 'h4',
  H5: 'h5',
  H6: 'h6',
};

export interface HeadingProps {
  headingSize?: titleSizeType;
}

export default function Heading(props: PropsWithChildren<HeadingProps>) {
  const { headingSize = 'H1', children } = props;
  const Tag = HeadingSizeMap[headingSize];

  return <Tag className={styles.wrapper}>{children}</Tag>;
}
